// #region Imports

import * as $ from 'jquery';

// #endregion Imports

// #region Exports

export function initialize(): void {
    toggleAriaState();
}

// #endregion Exports

// #region Private functions

export function toggleAriaState($context?: any): void {
    const selectors = [
        'button[aria-pressed]',
        '.js-aria-state',
        '.js-aria-expanded'
    ];
    const $elements = ($context && $context.length && $context.find)
        ? $context.find(selectors.join(','))
        : $(selectors.join(','));
    

    $elements.on('click', handleButtonPress);
    bindClickedOutside($elements);
}
   
/*
Close/set aria-pressed to false when clicking outside of the current element or the selector set in the data attribute
*/
function bindClickedOutside($elements: JQuery): void {
    const closeOnClickOutsideDataAttrubute = 'close-on-click-outside';
    const $filteredElements = $elements.filter(`[data-${closeOnClickOutsideDataAttrubute}]`);
    $(document as any).on('click', (e: any) => {
        $filteredElements.each((i, elem) => {  
            const closeOutsideSelector = $(elem).data(closeOnClickOutsideDataAttrubute);
            //alert(closeOutsideSelector);
            if(closeOutsideSelector) {
                if (!$(elem).is(e.target) 
                    && $(elem).has(e.target).length === 0
                    && !$(closeOutsideSelector).is(e.target)
                    && $(closeOutsideSelector).has(e.target).length === 0
                ) {
                    $(elem).attr('aria-pressed', (false) as any);  
                    $(elem).attr('aria-expanded', (false) as any); 
                    if (closeOutsideSelector == '.teaser__content') {
                        $("html").removeClass("scroll-lock");
                    }
                }
            }
        });       
    });
}

function handleButtonPress(e:any) : void {
    e.preventDefault();
    const $this = $(this);
    const context = $this.data('context');
    const newState = ($this.attr('aria-pressed') === 'false');
    const newExpandedState = ($this.attr('aria-expanded') === 'false');
    const newSelectedState = ($this.attr('aria-selected') === 'false');

    if ($this.hasClass('pullDownIcon')) {
        $(".note__content.note__content--active").removeClass('note__content--active');
        document.body.classList.remove('note-editor-open');
        $this.attr('aria-label', newState
            ? 'Dölj relaterade kurser'
            : 'Fäll ut relaterade kurser');
    }

    if ($this.hasClass('facts__link')) {
        $('.js-aria-state').attr('aria-pressed', false as any);
    }

    if ($this.hasClass('fact-table-toggle')) {
        $('.js-aria-state:not(.facts__link)').attr('aria-pressed', false as any);

    } else if ($this.hasClass('no-reset_block-menu')) {
        $('.js-aria-state:not(.packages-block__link)').attr('aria-pressed', false as any);

    } else {
        $('.js-aria-state').attr('aria-pressed', false as any);
    }

    if (typeof (context) === 'string' && context.length > 0) {
        closeAllOfContext(context);
    }

    if ($this.hasClass('packages-block__link')) {
        $('.js-aria-state').attr('aria-selected', false as any);
        $('.js-aria-state').attr('aria-expanded', false as any);
        $this.attr('aria-selected', (newSelectedState) as any);
        $this.attr('aria-expanded', (newExpandedState) as any);
    }

    if ($this.hasClass('js-modal-focus-trap')) {
        e.stopPropagation();
        const target = "#" + $(this).data('modalid');
        const $modal = $(target);

        const $trigger = $(this);
        $modal.data('trigger', $trigger);

        $("html").addClass("scroll-lock");

        $modal.focus();

        trapFocusAndEsc($modal[0]);
    }

    if ($this.hasClass('js-close-modal')) {
        const target = "#" + $(this).data('nextfocus');
        clickCloseAllOpenModals(target);
    }

    $this.attr('aria-pressed', (newState) as any);
    $this.attr('aria-expanded', (newExpandedState) as any);
    $this.trigger('aria-pressed', [
        { state: {
            pressed: newState
        } }
    ]);

    if (newState === false) {
        document.body.classList.remove("modal-open") 
    } else {
        document.body.classList.add("modal-open")
    }
}

function closeAllOfContext(context: string) {
    $(`button[data-context="${context}"], .js-aria-state[data-context="${context}"]`).attr('aria-pressed', false as any);
    $(`.js-aria-state[data-context="${context}"]`).attr('aria-expanded', false as any);
}

document.addEventListener("keydown", (e) => closeAllOpenModals(e), false);

function closeAllOpenModals(e: KeyboardEvent){
    if (e.key === "Escape") {
        $("html").removeClass("scroll-lock");
        if (document.body.classList.contains('modal-open')) {
            document.body.classList.remove("modal-open")
        }
        $('.js-aria-state:not(.facts__link').attr('aria-pressed', false as any);
        $('.js-aria-state:not(.facts__link').attr('aria-expanded', false as any);
    }
}

function clickCloseAllOpenModals(target: string) {
    const $openBtn = $(target);
    $("html").removeClass("scroll-lock");
    if (document.body.classList.contains('modal-open')) {
        document.body.classList.remove("modal-open")
    }
    $('.js-aria-state').attr('aria-pressed', false as any);
    $('.js-aria-state').attr('aria-expanded', false as any);

    $openBtn.focus();
}

function trapFocusAndEsc(modal: HTMLElement) {

    const focusableSelectors = `
        a[href],
        button:not([disabled]),
        video[controls],
        textarea,
        input,
        select,
        [tabindex]:not([tabindex="-1"])
    `;

    const focusableElements = modal.querySelectorAll(focusableSelectors);
    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    function handleKeydown(e: { key: string; shiftKey: any; preventDefault: () => void; }) {

        if (e.key === 'Tab') {
            if (e.shiftKey) { // Shift + Tab
                if (document.activeElement === firstElement) {
                    e.preventDefault();
                    lastElement.focus();
                }
            } else { // Tab
                if (document.activeElement === lastElement) {
                    e.preventDefault();
                    firstElement.focus();
                }
            }
        }

        if (e.key === 'Escape') {
            const closeButton = modal.querySelector('.js-close-video');
            if (closeButton) closeButton.click();
        }
    }

    modal.addEventListener('keydown', handleKeydown);
    modal._handleKeydown = handleKeydown; // spara referens för att ta bort senare
}
// #endregion Private functions